import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SleepHealthIccEntity, SleepHealthIccParams } from '@models/health/sleep-health-icc.model';
import { SleepHealthEntity, SleepHealthParams } from '@models/health/sleep-health.model';
import { WellnessReportEntityModel, WellnessReportParams } from '@models/health/wellness-report.model';
import { SiqPopupHelper } from '@shared/utils/helpers/siq-popup.helper';
import { Observable, catchError, map, throwError } from 'rxjs';
import { EnvironmentsService } from './environments.service';
import { MixpanelService } from './mixpanel.service';
import { SiqApiService } from './siq-api.service';
import { SplashScreenService } from './splash-screen.service';

@Injectable({
  providedIn: 'root'
})
export class HealthService extends SiqApiService {

  constructor(
    httpClient: HttpClient,
    environmentService: EnvironmentsService,
    mixpanelService: MixpanelService,
    siqPopupHelper: SiqPopupHelper,
    splashScreenService: SplashScreenService) {
    super(httpClient, environmentService, mixpanelService, siqPopupHelper, splashScreenService);
  }

  getSleepHealth(accountId: string, sleeperId: string, data: SleepHealthParams): Observable<SleepHealthEntity> {
    return this.makeSiqRequest<SleepHealthEntity, SleepHealthParams>(
      `sn/v1/accounts/${accountId}/sleepers/${sleeperId}/mySleepHealth/metrics`,
      'siq', data, 'GET', false).pipe(
        map((response: SleepHealthEntity | HttpErrorResponse) => {
          if (response instanceof HttpErrorResponse) {
            throw response;
          }
          return response;
        }),
        catchError((error: HttpErrorResponse) => throwError(() => error))
      );
  }

  getSleepHealthIcc(accountId: string, sleeperId: string, data: SleepHealthIccParams): Observable<SleepHealthIccEntity> {
    return this.makeSiqRequest<SleepHealthIccEntity, object>(
      `sn/v1/accounts/${accountId}/sleepers/${sleeperId}/mySleepHealth/messages?sessionStartDate=${data.sessionStartDate}&isEdited=${data.isEdited}`,
      'siq', {}, 'PUT', false).pipe(
        map((response: SleepHealthIccEntity | HttpErrorResponse) => {
          if (response instanceof HttpErrorResponse) {
            throw response;
          }
          return response;
        }),
        catchError((error: HttpErrorResponse) => throwError(() => error))
      );
  }

  getWellnessReport(accountId: string, sleeperId: string, data: WellnessReportParams): Observable<WellnessReportEntityModel> {
    return this.makeSiqRequest<WellnessReportEntityModel, WellnessReportParams>(
      `sn/v1/accounts/${accountId}/sleepers/${sleeperId}/reports/wellness`,
      'siq', data, 'GET', false).pipe(
        map((response: WellnessReportEntityModel | HttpErrorResponse) => {
          if (response instanceof HttpErrorResponse) {
            throw response;
          }
          return response;
        }),
        catchError((error: HttpErrorResponse) => throwError(() => error))
      );
  }

  downloadWellnessReport(accountId: string, sleeperId: string, date: string): any {
    return this.makeSiqRequest<string, Record<string, string>>(
      `sn/v1/accounts/${accountId}/sleepers/${sleeperId}/download/reports/wellness`,
      'siq', { date }, 'GET', false, 'text').pipe(
        map((response: string | HttpErrorResponse) => {
          if (response instanceof HttpErrorResponse) {
            throw response;
          }
          return response;
        }),
        catchError((error: HttpErrorResponse) => throwError(() => error))
      );
  }
}
